// This is a wrapper around PublisherInfo that allows us to switch to PublisherApps
// when the user is logged in and the user is the same as the publisher.

import React from 'react';
// import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { useMatch } from 'react-router-dom';

import AORTypes from '../../types';
import PublisherInfo from './PublisherInfo';
import PublisherApps from '../publisher/create/PublisherApps';
import { withSideMenuConsumer, withSideMenuPublisher } from '../../components/nav/SideMenu';

const MPublisherInfo = withSideMenuConsumer(PublisherInfo);
const MPublisherApps = withSideMenuPublisher(PublisherApps);
export default function PublisherInfoSwitch(props) {
  const { user } = props;

  const match = useMatch("/publisher/:uuid");

  if (user && (!match || (match.params.uuid && match.params.uuid === user.attributes.sub))) {
    return <MPublisherApps {...props} />;
  }
  return (
    <MPublisherInfo {...props} />
  );
}

PublisherInfoSwitch.defaultProps = {
  user: undefined,
};

PublisherInfoSwitch.propTypes = {
  user: AORTypes.User,
};
